import React, { useEffect, useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import api from '../login/interceptors';
import { handleLogout } from './authHelpers';
import { fetchMe, orgErrorMessage } from '../../utils/organisationApi';

const ProtectedRoute = () => {
  const navigate = useNavigate();
  const token = localStorage.getItem("jwtToken");
  const [ready, setReady] = useState(false);
  const [loadError, setLoadError] = useState("");

  useEffect(() => {
    let cancelled = false;
    const checkAuth = async () => {
      if (!token) {
        navigate("/login", { replace: true });
        return;
      }
      try {
        const response = await api.post(`/api/valid-session/`, {});
        if (response.status === 401 || response.status === 403) {
          handleLogout();
          return;
        }
        // Signed-in profile: user, active organisation, role, permissions, switcher list
        await fetchMe();
        if (!cancelled) {
          setLoadError("");
          setReady(true);
        }
      } catch (error) {
        const status = error?.response?.status;
        if (status === 401 || status === 403) {
          handleLogout();
          return;
        }
        console.error('Could not load the signed-in profile:', error);
        if (!cancelled) setLoadError(orgErrorMessage(error, "Could not load your account."));
      }
    };

    checkAuth();
    return () => {
      cancelled = true;
    };
  }, [token, navigate]);

  if (!token) return null;
  if (loadError) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center gap-3 px-6 text-center">
        <p className="text-accent-red">{loadError}</p>
        <button type="button" className="text-accent-blue hover:underline" onClick={() => window.location.reload()}>
          Try again
        </button>
      </div>
    );
  }
  if (!ready) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full border-t-4 border-blue-500 w-12 h-12" />
      </div>
    );
  }
  return <Outlet />;
};

export default ProtectedRoute;
